import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';

import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';

const ApprovalLineForm = ({ formik }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState(null);
  const [title, setTitle] = useState("사원찾기");
  const openEmpModal = (type, title) => {
    setType(type);
    setTitle(title)
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
    setType(null);
  }

  const selectedEmployee = (emp) => {
    formik.setFieldValue(`usrName${type}`, emp.usrNm, true);
    formik.setFieldValue(`usrUuid${type}`, emp.usrUuid, false);
  }



  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 2,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            my: 1
          }}
        >
          <Grid item xs={4}>
            <TextField
              variant="standard"
              required
              fullWidth
              id="apprNm"
              name="apprNm"
              label="결재선명"
              value={formik.values.apprNm}
              onChange={formik.handleChange}
              error={formik.touched.apprNm && Boolean(formik.errors.apprNm)}
              helperText={formik.touched.apprNm && formik.errors.apprNm}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant="standard"
              disabled
              required
              fullWidth
              id="usrName1"
              name="usrName1"
              label="결재자1"
              value={formik.values.usrName1}
              onChange={formik.handleChange}
              error={formik.touched.usrName1 && Boolean(formik.errors.usrName1)}
              helperText={formik.touched.usrName1 && formik.errors.usrName1}
            />
          </Grid>
          <Grid item xs={1}><Button variant="outlined" size="small" onClick={() => openEmpModal('1', '결재자1 선택')}>결재자1 선택</Button></Grid>
          <Grid item xs={3}>
            <TextField
              variant="standard"
              disabled
              fullWidth
              id="usrName2"
              name="usrName2"
              label="결재자2"
              value={formik.values.usrName2}
              onChange={formik.handleChange}
              error={formik.touched.usrName2 && Boolean(formik.errors.usrName2)}
              helperText={formik.touched.usrName2 && formik.errors.usrName2}
            />
          </Grid>
          <Grid item xs={1}><Button variant="outlined" size="small" onClick={() => openEmpModal('2', '결재자2 선택')}>결재자2 선택</Button></Grid>

        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={3}>
            <TextField
              variant="standard"
              disabled
              fullWidth
              id="usrName3"
              name="usrName3"
              label="결재자3"
              value={formik.values.usrName3}
              onChange={formik.handleChange}
              error={formik.touched.usrName3 && Boolean(formik.errors.usrName3)}
              helperText={formik.touched.usrName3 && formik.errors.usrName3}
            />
          </Grid>
          <Grid item xs={1}><Button variant="outlined" size="small" onClick={() => openEmpModal('3', '결재자3 선택')}>결재자3 선택</Button></Grid>
          <Grid item xs={3}>
            <TextField
              variant="standard"
              disabled
              fullWidth
              id="usrName4"
              name="usrName4"
              label="결재자4"
              value={formik.values.usrName4}
              onChange={formik.handleChange}
              error={formik.touched.usrName4 && Boolean(formik.errors.usrName4)}
              helperText={formik.touched.usrName4 && formik.errors.usrName4}
            />
          </Grid>
          <Grid item xs={1}><Button variant="outlined" size="small" onClick={() => openEmpModal('4', '결재자4 선택')}>결재자4 선택</Button></Grid>
          <Grid item xs={3}>
            <TextField
              variant="standard"
              disabled
              fullWidth
              id="usrName5"
              name="usrName5"
              label="결재자5"
              value={formik.values.usrName5}
              onChange={formik.handleChange}
              error={formik.touched.usrName5 && Boolean(formik.errors.usrName5)}
              helperText={formik.touched.usrName5 && formik.errors.usrName5}
            />
          </Grid>
          <Grid item xs={1}><Button variant="outlined" size="small" onClick={() => openEmpModal('5', '결재자5 선택')}>결재자5 선택</Button></Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            my: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
        <EmpModalContainer
          title={title}
          multi={false}
          open={open}
          handleClose={handleClose}
          selectedEmployee={selectedEmployee}
        />
      </Box>
    </div>
  );
};

export default ApprovalLineForm;
